"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectWithLabel = exports.Select = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
function Select() {
    return function (props) { return (React.createElement(core_1.Popover, { minimal: true, target: React.createElement(core_1.Button, { className: "fw6", minimal: true, fill: true, intent: core_1.Intent.PRIMARY, title: props.title, rightIcon: "double-chevron-down", text: props.selectionRenderer(props.defaultSelection) }), content: React.createElement(core_1.Menu, null,
            props.options.map(function (option, index, array) { return (React.createElement(core_1.MenuItem, { disabled: props.disabled ? props.disabled : false, key: "select_".concat(props.id, "_").concat(index), intent: props.isEqual(option, props.defaultSelection) ? core_1.Intent.PRIMARY : core_1.Intent.NONE, icon: props.isEqual(option, props.defaultSelection) ? 'tick' : 'blank', text: props.selectionRenderer(option), onClick: function () { return props.disableConfirmation ?
                    props.handleSelection(option)
                    : core_1.Toaster.create({
                        canEscapeKeyClear: false,
                        autoFocus: true,
                        position: core_1.Position.TOP,
                        className: 'absolute'
                    }).show({
                        intent: core_1.Intent.WARNING,
                        icon: 'warning-sign',
                        timeout: 10000,
                        message: "Sure you want to change selection from ".concat(props.defaultSelection ?
                            props.selectionRenderer(props.defaultSelection)
                            : 'None', " to ").concat(props.selectionRenderer(option), " ?"),
                        action: {
                            onClick: function () { return props.handleSelection(option); },
                            icon: 'changes',
                            text: "Change ".concat(props.title)
                        }
                    }); } })); }),
            React.createElement(core_1.MenuItem, { disabled: props.disabled ? props.disabled : false, key: "select_".concat(props.id, "_none"), intent: props.defaultSelection === undefined ?
                    core_1.Intent.PRIMARY : core_1.Intent.NONE, icon: props.defaultSelection === undefined ? 'tick' : 'blank', text: "None", onClick: function () { return props.disableConfirmation ?
                    props.handleSelection(undefined)
                    : core_1.Toaster.create({
                        canEscapeKeyClear: false
                    }).show({
                        intent: core_1.Intent.WARNING,
                        icon: 'warning-sign',
                        message: "Sure you want to change selection from ".concat(props.defaultSelection ?
                            props.selectionRenderer(props.defaultSelection)
                            : 'None', " to None ?"),
                        action: {
                            onClick: function () { return props.handleSelection(undefined); },
                            icon: 'changes',
                            text: 'Change Sponser'
                        }
                    }); } })) })); };
}
exports.Select = Select;
function SelectWithLabel() {
    var GenericSelect = Select();
    return function (props) { return (React.createElement(core_1.FormGroup, { label: React.createElement("span", { className: "fw5 f5" }, props.label), labelFor: props.id },
        React.createElement(GenericSelect, __assign({}, props)))); };
}
exports.SelectWithLabel = SelectWithLabel;
//# sourceMappingURL=Select.js.map